import { ApolloClient, InMemoryCache, HttpLink } from 'apollo-boost'
import fetch from 'isomorphic-unfetch'
import { setContext } from 'apollo-link-context'
import { environments } from 'utils/Environments'

function getServerGqlEndpoint(environment, url) {
  if (process.browser || environment === environments.DEVELOPMENT) {
    return url
  }
  return 'http://cgc-app:3000/api/graphql'
}

// TODO: Add comments
function getHttpLink(url, environment) {
  const httpLink = new HttpLink({
    uri: getServerGqlEndpoint(environment, url),
    credentials: 'same-origin',
    fetch: !process.browser && fetch,
  })

  if (environment !== environments.STAGING) {
    return httpLink
  }

  const btoa = require('btoa')
  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: 'Basic ' + btoa('careguidebeta:testdemo'),
      },
    }
  })
  return authLink.concat(httpLink)
}

let apolloClient = null
function create(initialState, url, environment) {
  return new ApolloClient({
    connectToDevTools: process.browser,
    ssrMode: !process.browser,
    link: getHttpLink(url, environment),
    cache: new InMemoryCache({
      // This function below is used to create the keys for apollo's in memory cache.
      // It overides the default behavior to add custom behavior for meta tag types which may not have id fields.
      // This allows apollo cache to store the values from queries or mutations properly(no duplicates or data loss)
      dataIdFromObject: (object) => {
        if (object.id) {
          return `${object.__typename}-${object.id}`
        }
        if (object._id) {
          return `${object.__typename}:${object._id}`
        }
        if (object.cursor) {
          return `${object.__typename}-${object.cursor}`
        }
        if (object.__typename === 'MetaTag') {
          return `${object.__typename}-${object.content}`
        }
        return null
      },
    }).restore(initialState || {}),
  })
}

export default function initApollo(initialState, url, environment) {
  if (!process.browser) {
    return create(initialState, url, environment)
  }

  if (!apolloClient) {
    apolloClient = create(initialState, url, environment)
  }

  return apolloClient
}
